import { Theme } from '@infotech-soe/erp-ui-kit';
import { Stimulsoft } from '@infotech-soe/stimulsoft-reports-js/Scripts/stimulsoft.viewer';
import React, { useCallback, useEffect, useState } from 'react';
import { useTheme } from 'react-jss';

import { ReportControlViewModel } from '../../../services/form/view-model/FormControlViewModel';
import PrintService from '../../../services/print/PrintService';
import { useAppSelector } from '../../../store/hooks';
import { isDarkTheme } from '../../../store/selectors/theme';
import useRuntimeConfig from '../../hooks/useRuntimeConfig';
import { setLicenseKey, StimulsoftViewer } from '../report-viewer';

interface FormReportControlProps {
  control: ReportControlViewModel;
}

const STI_VIEWER_DEFAULT_HEIGHT = '60vh';

const FormReportControl = ({
  control,
}: FormReportControlProps): React.JSX.Element | null => {
  // eslint-disable-next-line no-console
  const handleError = useCallback((e: Error) => console.error(e), []);
  const runtimeConfig = useRuntimeConfig(handleError);
  const isDarkMode = useAppSelector(isDarkTheme);
  const [reportTemplate, setReportTemplate] = useState<string>();
  const theme = useTheme<Theme>();

  useEffect(() => {
    const load = async () => {
      const loadedTemplate = await new PrintService().getTemplate(
        control.template
      );
      setReportTemplate(loadedTemplate);
    };
    void load();
  }, [control.template]);

  if (!runtimeConfig?.stiLicenseKey) {
    return null;
  }

  setLicenseKey(runtimeConfig.stiLicenseKey);

  return (
    <StimulsoftViewer
      language="uk"
      reportData={control.value ?? undefined}
      reportTemplate={reportTemplate}
      variables={control.variables}
      parseDates={false}
      isDarkMode={isDarkMode}
      toolbar={{
        visible: false,
        viewMode: Stimulsoft.Viewer.StiWebViewMode.Continuous,
      }}
      appearance={{
        allowSelectionCurrentPage: false,
        backgroundColor: theme.colors.surface,
        pageBorderColor: Stimulsoft.System.Drawing.Color.empty,
        scrollbarsMode: true,
      }}
      height={control.height || STI_VIEWER_DEFAULT_HEIGHT}
    />
  );
};

export default FormReportControl;
